export default __webpack_public_path__ + "static/media/demetz.a1041098.svg";